import React, { useState } from "react";
import { FaCheck, FaTimes } from "react-icons/fa";
import Time from "react-time-format";
import ElementContainer from "../../../shared/ElementContainer";
import Modal from "components/shared/Modal";

class QuizElement extends React.Component {
  render() {
    const {
      quiz,
      quizAttempts,
      titleColor,
      completed,
      requirable,
      page,
      pageType,
      courseId,
      id,
      min_score,
      hide_score,
      user,
      token,
    } = this.props;

    return (
      <ElementContainer
        id={id}
        color={titleColor}
        title={quiz.name}
        requirable={requirable}
        completed={completed}
        icon={"bxs-edit"}
        user={user}
        token={token}
      >
        {quiz.time_limit > 0 ? (
          <div className="m-bottom-1 text-center">
            Complete activity with a minimum passing score: {min_score}% within{" "}
            {quiz.time_limit} minutes
          </div>
        ) : (
          <div className="m-bottom-1 text-center">
            Complete activity with a minimum passing score: {min_score}%
          </div>
        )}
        <StartActivity
          pageType={pageType}
          page={page}
          id={id}
          quiz={quiz}
          user={user}
          courseId={courseId}
          startUrl={
            this.props.start_url ||
            this.props.startUrl ||
            (this.props.custom && this.props.custom.start_url)
          }
          authenticityToken={
            this.props.authenticity_token ||
            this.props.authenticityToken ||
            this.props.token ||
            (this.props.custom && this.props.custom.authenticity_token)
          }
          openInNewTab={
            this.props.open_in_new_tab ||
            (this.props.custom && this.props.custom.open_in_new_tab)
          }
        />
        <Attempts
          attempts={quizAttempts}
          minimum={min_score}
          hide_score={hide_score}
        />
      </ElementContainer>
    );
  }
}

const StartActivity = (props) => {
  const {
    pageType,
    page,
    courseId,
    id,
    quiz,
    user,
    startUrl, // injected from Rails (admin)
    authenticityToken, // injected from Rails (admin)
    openInNewTab,
  } = props;

  const [display, setDisplay] = useState(false);

  // Prefer server-provided URL in admin; otherwise build the public route
  const action =
    startUrl ||
    (courseId != null
      ? `/u/mp/${pageType}/${courseId}/${page}/quiz_attempts`
      : `/u/mp/${pageType}/${page}/quiz_attempts`);

  // Prefer injected token; otherwise fall back to <meta name="csrf-token">
  const token =
    authenticityToken ||
    document.querySelector('meta[name="csrf-token"]')?.content ||
    "";

  const ModalHeader = ({ title }) => {
    const span = { position: "absolute", top: 15, right: 15 };
    const btn = { cursor: "pointer", color: "lightgray" };
    return (
      <div className="modal-header">
        <h2 className="text-center">{title}</h2>
        <span style={span}>
          <a onClick={() => setDisplay(false)} style={btn}>
            <FaTimes className="icon-medium" />
          </a>
        </span>
      </div>
    );
  };

  return (
    <form
      action={action}
      method="post"
      target={openInNewTab ? "_blank" : undefined}
    >
      <input type="hidden" name="authenticity_token" value={token} />
      <input type="hidden" name="quiz_attempt[quiz_id]" value={quiz.id} />
      <input type="hidden" name="quiz_attempt[quiz_element_id]" value={id} />
      <input type="hidden" name="quiz_attempt[user_id]" value={user.id} />

      {quiz.time_limit > 0 ? (
        <div
          className="btn btn-secondary radius expand drop-shadow"
          onClick={() => setDisplay(true)}
          role="button"
        >
          Start Activity
        </div>
      ) : (
        <input
          type="submit"
          className="btn btn-secondary radius expand drop-shadow"
          value="Start Activity"
        />
      )}

      <Modal display={display} modalId={quiz.id}>
        <ModalHeader title={"Notice!"} />
        <div className="modal-body">
          <p className="text-center">
            You are about to start a time-based activity
            <br />
            that allows for{" "}
            <span className="primary-text">{quiz.time_limit} minutes</span>.
            <br />
            Are you sure you want to start it?
          </p>
          <input
            type="submit"
            className="btn radius expand"
            value="Acknowledge and Start Activity"
          />
        </div>
      </Modal>
    </form>
  );
};

const Attempts = (props) => {
  const { attempts, minimum, hide_score } = props;
  return (
    <div>
      <table>
        <thead>
          <tr>
            <th className="text-center">Started</th>
            <th className="text-center">Completed</th>
            {!hide_score && (
              <>
                <th className="text-center">Questions (Correct/Total)</th>
                <th className="text-origin-center">Score</th>
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {attempts.map((a) => (
            <tr key={a.id}>
              <td className="text-center">
                <Time value={a.created_at} format="MM/DD/YYYY" />
              </td>
              <td className="text-center">{a.closed ? <FaCheck /> : "~~~"}</td>
              {!hide_score && (
                <>
                  <td className="text-center">
                    {a.point_total} / {a.points_available}
                  </td>
                  <td
                    className={
                      a.score > minimum
                        ? "primary radius text-center"
                        : "secondary radius text-center"
                    }
                  >
                    {a.score}%
                  </td>
                </>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default QuizElement;
